import { Link, usePage } from '@inertiajs/react'
import { forgeNavigationPath, forgeProjectId } from '@/frontend/layouts/worker-first/forgeNavigation'
import type { SharedProps } from '@/frontend/types/inertia'

export default function SectionTabs() {
  const { props, url } = usePage<SharedProps>()
  const copy = props.navigationLabels.forge
  const projectId = forgeProjectId(url, props.forgeAccess?.default_project_id)
  const parent = forgeNavigationPath(url)
  const query = new URLSearchParams(url.split('?')[1] || '')
  const root = '/dashboard/discovery'
  let tabs: Array<{ label: string; path: string; selected: boolean }> = []
  if (parent === `${root}/workspace`) {
    const channel = url.startsWith(`${root}/project_whatsapp_sources`)
    const meeting = url.startsWith(`${root}/timeline`)
    const memory = !channel && !meeting && query.get('view') === 'knowledge'
    tabs = [
      { label: copy.files, path: `${root}/workspace`, selected: !channel && !meeting && !memory },
      { label: copy.meetings, path: `${root}/timeline`, selected: meeting },
      { label: copy.channels, path: `${root}/project_whatsapp_sources`, selected: channel },
      { label: copy.memory, path: `${root}/workspace`, selected: memory },
    ]
  } else if (parent === `${root}/people`) {
    tabs = (['participants', 'agents', 'access'] as const).map((key) => ({ label: copy[key], path: `${root}/people`, selected: (query.get('section_view') || 'participants') === key }))
  }
  if (!tabs.length || !projectId) return null
  return <nav aria-label={parent === `${root}/people` ? copy.people : copy.knowledge} className="flex shrink-0 gap-5 overflow-x-auto border-b border-border px-4 md:px-6">
    {tabs.map((tab, index) => {
      const params = new URLSearchParams({ project_id: projectId })
      if (parent === `${root}/people` && index > 0) params.set('section_view', index === 1 ? 'agents' : 'access')
      if (parent === `${root}/workspace` && index === 3) params.set('view', 'knowledge')
      return <Link key={tab.label} href={`${tab.path}?${params}`} aria-current={tab.selected ? 'page' : undefined} className={`whitespace-nowrap border-b-2 py-3 text-xs font-medium ${tab.selected ? 'border-foreground text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground'}`}>{tab.label}</Link>
    })}
  </nav>
}
